<template>

  <div>

    <v-container fluid class="pa-0">

      <v-layout>

        <v-flex shrink>

          <v-btn v-if="referrerText"
                 small
                 depressed
                 block
                 class="my-2"
                 :to="{ name: referrer }">
            <v-icon left>mdi-arrow-left</v-icon>
            Back to {{referrerText}}
          </v-btn>

          <v-card flat class="app-height pt-3">

            <div class="mx-4">
              <h3 class="title">
                {{$route.meta.pageTitle}}
              </h3>
            </div>

            <v-list dense shaped nav subheader color="transparent">

              <v-list-item active-class="accent black--text"
                           :ripple="false"
                           v-for="(provider, index) in providers"
                           :key="index"
                           :to="{ name: 'provider-detail', params: { id : provider.properties.ProviderID }}"
              >

                <v-list-item-icon class="hidden-lg-and-down">
                  <v-icon>network_cell</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    {{provider.properties.ProviderName}}
                  </v-list-item-title>
                </v-list-item-content>

              </v-list-item>

            </v-list>

          </v-card>

        </v-flex>

        <v-flex>

          <router-view></router-view>

        </v-flex>

      </v-layout>

    </v-container>

  </div>

</template>

<script>
import startCase from 'lodash/startCase';

const name = 'Providers';

export default {

  name,

  data() {
    return {};
  },

  created() {
    console.log('created providers');
    this.selectDefaultProvider();
  },

  methods: {

    selectDefaultProvider() {
      // select the first provider as the default, and push that $route
      if (!this.$route.params.id && this.providers.length) {
        console.log('routing to default provider');
        this.$router.push({
          name: 'provider-detail',
          params: {
            id: this.providers[0].properties.ProviderID,
          },
        });
      }
    },

  },

  watch: {

    providers() {
      // if no provider ID is specified, than pick the default provider
      this.selectDefaultProvider();
    },

  },

  computed: {

    providers() {
      // compute the readable name using startCase of the referrer from the query params
      return this.$store.state.data.providers;
    },

    referrer() {
      return this.$store.state.route.query.referrer;
    },

    referrerText() {
      // compute the readable name using startCase of the referrer from the query params
      return this.referrer ? startCase(this.referrer) : null;
    },

  },

};
</script>
